import { API_LIMIT_DATA } from '../utils/constants';
import { Axios } from './Axios';

export function getAllNotification(orgId, offset = 1, limit = API_LIMIT_DATA) {
  const url = `notification?orgId=${orgId}&limit=${limit}&page=${offset}`;
  return Axios({
    url,
    method: 'get'
  });
}

export function updateNotification(id, data) {
  const url = `notification/${id}`;
  return Axios({
    url,
    method: 'patch',
    data
  });
}
